/* global localStorage */
import { createRequestActions } from 'actions';
import * as types from 'constants/ActionTypes.js';
import { ROOT_URL } from 'constants/Config.js';
import axios from 'axios';

export const loadProfile = createRequestActions({
  type: 'LOAD_PROFILE',
  url: '/user/profile'
});

export const leaveProfileAgency = createRequestActions({
  type: 'LEAVE_PROFILE_AGENCY',
  url: '/user/agency/exit',
  method: 'post'
});

export const updateProfile = createRequestActions({
  type: 'UPDATE_PROFILE',
  url: '/user/update',
  method: 'post'
});

export const updateProfileSurvey = createRequestActions({
  type: 'UPDATE_PROFILE_SURVEY',
  url: '/user/update',
  method: 'post'
});

export const updateProfileRegion = createRequestActions({
  type: 'UPDATE_PROFILE_REGION',
  url: '/user/update',
  method: 'post'
});

export const createProfile = createRequestActions({
  type: 'CREATE_PROFILE',
  url: '/user/create',
  method: 'post'
});

export const loadAgentProfile = createRequestActions({
  type: 'LOAD_AGENT_PROFILE',
  url: '/user/profile'
});

export const updateAgentProfile = createRequestActions({
  type: 'UPDATE_AGENT_PROFILE',
  url: '/user/update',
  method: 'post'
});

export const loadCompanyProfiles = createRequestActions({
  type: 'LOAD_COMPANY_PROFILES',
  url: '/user/agency/list'
});

export const deleteProfile = createRequestActions({
  type: 'DELETE_PROFILE',
  url: '/user/agent/delete',
  method: 'post'
});

export const loadCompany = createRequestActions({
  type: 'LOAD_COMPANY',
  url: '/user/agency/get'
});

export const updateCompany = createRequestActions({
  type: 'UPDATE_COMPANY',
  url: '/user/create/agency',
  method: 'post'
});

export const uploadPhoto = createRequestActions({
  type: 'UPLOAD_PHOTO',
  url: '/image/upload',
  method: 'post'
});

export const uploadAgentPhoto = createRequestActions({
  type: 'UPLOAD_AGENT_PHOTO',
  url: '/image/upload',
  method: 'post'
});

export function uploadLogo(data) {
  return dispatch => {
    dispatch({ type: types.UPLOAD_LOGO_REQUEST, data: 'adfadfadfadfa' });
    return axios.post(`${ROOT_URL}/image/upload`, data)
      .then((res) => {
        dispatch({ type: types.UPLOAD_LOGO_OK, payload: { response: res.data.data } });
        return res.data.data;
      })
      // .then((res) => {
      //   return axios.post(`${ROOT_URL}/user/update`, { avatarId: res.imageId });
      // })
      .catch(error => {
        dispatch({ type: types.UPLOAD_LOGO_ERROR, payload: error });
      });
  };
}

export function checkUserPhone(data) {
  const { phone, agencyId } = data;

  return dispatch => {
    dispatch({ type: 'CHECK_USER_PHONE_REQUEST', meta: { loader: true } });

    return axios.get(`${ROOT_URL}/user/check/${phone}/${agencyId}`, {}).then((response) => {
      dispatch({ type: 'CHECK_USER_PHONE_SUCCESS', payload: response.data });

      return response.data;
    }).catch(error => {
      console.error(error);
      dispatch({ type: 'CHECK_USER_PHONE_ERROR', payload: error });

      throw error;
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/profile.js